module.exports = __webpack_public_path__ + "static/media/User Flow.878c654d.png";